import React, { useEffect, useState } from "react";
import AdminPageHeader from "../../components/AdminPageHeader";
import {
  getAllOpenShifts,
  awardShift,
  denyShiftRequest,
  sortShiftRequests,
} from "../../lib/firebase";

export default function ShiftRequests() {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [awardingId, setAwardingId] = useState(null);

  useEffect(() => {
    loadShifts();
  }, []);

  async function loadShifts() {
    setLoading(true);
    try {
      const data = await getAllOpenShifts();
      setShifts(data);
    } catch (err) {
      console.error(err);
      alert("Failed to load shift requests");
    }
    setLoading(false);
  }

  async function handleAward(shift, request) {
    if (!window.confirm(`Assign ${request.name} to this shift?`)) return;

    try {
      setAwardingId(shift.id);
      await awardShift(shift, request);
      await loadShifts();
    } catch (err) {
      console.error(err);
      alert(err.message);
    } finally {
      setAwardingId(null);
    }
  }

  async function handleDeny(shift, request) {
  if (!window.confirm(`Deny ${request.name || request.email || "this request"}?`)) return;

  try {
    setAwardingId(shift.id);
    await denyShiftRequest(shift.id, request.uid);
    await loadShifts();
  } catch (err) {
    console.error(err);
    alert(err.message);
  } finally {
    setAwardingId(null);
  }
}

  if (loading) {
    return <div style={{ padding: 20 }}>Loading shift requests…</div>;
  }

  return (
    <div style={{ padding: 20 }}>
      <AdminPageHeader title="Shift Requests" />

      <div style={{ marginTop: 10, color: "#64748b" }}>
        Review and award open shift requests
      </div>

      {shifts.length === 0 ? (
        <div style={{ marginTop: 20 }}>No open shifts.</div>
      ) : (
        <div style={{ marginTop: 20 }}>
          {shifts.map((shift) => {
            const requests = sortShiftRequests(shift.requests || []).filter(
            (r) => r.status !== "denied"
            );

            return (
              <div
                key={shift.id}
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: 16,
                  marginBottom: 16,
                  background: "#fff",
                }}
              >
                {/* SHIFT INFO */}
                <div style={{ fontWeight: 700, marginBottom: 6 }}>
                  {shift.assignment}
                </div>

                <div style={{ fontSize: 13, color: "#64748b" }}>
                  {shift.dateId} • {shift.roleLabel} • {shift.position}
                </div>

                {/* REQUESTS */}
                {requests.length === 0 ? (
                  <div style={{ marginTop: 10, fontSize: 13 }}>
                    No requests yet
                  </div>
                ) : (
                  <div style={{ marginTop: 12 }}>
                    {requests.map((req) => (
                      <div
                        key={req.uid}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "8px 0",
                          borderTop: "1px solid #f1f5f9",
                        }}
                      >
                        <div>
                          <div style={{ fontWeight: 600 }}>
                            {req.name || "Unknown"}
                          </div>
                          <div style={{ fontSize: 12, color: "#64748b" }}>
                            Hours at request: {req.scheduledHoursAtRequest || 0}
                          </div>
                        </div>

                        <div style={{ display: "flex", gap: 8 }}>
                        <button
                            className="btn btn-primary"
                            onClick={() => handleAward(shift, req)}
                            disabled={awardingId === shift.id}
                        >
                            Approve
                        </button>

                        <button
                            className="btn btn-secondary"
                            onClick={() => handleDeny(shift, req)}
                            disabled={awardingId === shift.id}
                        >
                            Deny
                        </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}